import Chip from "@material-ui/core/Chip";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import React, { Component } from "react";
import tournamentStatus from "../../constants/TournamentStatus";
import CloseTournamentContainer from "./CloseTournamentContainer";

class PSDTournamentRow extends Component {
  render() {
    let upgrade = this.props.upgrade;
    let tournament = this.props.tournament;
    return (
      <TableRow>
        <TableCell style={{ whiteSpace: "nowrap" }}>
          {moment
            .unix(
              upgrade.crqpsd
                ? moment(this.props.tournamentStatus.timestamp.toDate()).unix()
                : upgrade.created,
            )
            .format("dddd D MMMM YYYY HH:mm")}
        </TableCell>
        <TableCell>
          {tournamentStatus[upgrade.crqpsd ? 1 : upgrade.status].name +
            (tournament.crqpsd ? " (" + tournament.crqpsd + ")" : "")}
        </TableCell>

        <TableCell>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <span>{tournament.name}</span>
            {upgrade.isFirst && (
              <Chip
                size="small"
                label="Eerste toernooi"
                style={{
                  backgroundColor: "#FFF3E0",
                  color: "#795548",
                  border: "1px solid #FFB74D",
                  fontWeight: 400,
                  letterSpacing: 0.3,
                }}
              />
            )}
          </span>
        </TableCell>
        <TableCell>
          {tournament.liveLink && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://tournify.prosoccerdata.com/" + tournament.liveLink}
            >
              {"https://tournify.prosoccerdata.com/" + tournament.liveLink}
            </a>
          )}
        </TableCell>
        <TableCell>
          <CloseTournamentContainer
            user={this.props.user}
            tournament={tournament}
            tournamentStatus={this.props.tournamentStatus}
            psdPage={true}
            isTournifyAdmin={this.props.isTournifyAdmin}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default PSDTournamentRow;
